var MeetAjaxForProduct = function ajaxConstructor(settings) {
  var default_Data = {
    container: "#infinteLoop",
    method: "scroll",
    callback: null,
    loadingText: "Loading...",
    pagination: "#infinitePagination",
    offset: 0,
  };

  var data = settings || {};
  this.data = Object.assign(default_Data, data);

  this.meetProductClick = this.meetProductClick.bind(this);
  this.meetProductScroll = this.meetProductScroll.bind(this);
  this.meetProductDestroy = this.meetProductDestroy.bind(this);
  this.meetStopProductMultipleClicks =
    this.meetStopProductMultipleClicks.bind(this);
  this.meetProductPaginationlnView =
    this.meetProductPaginationlnView.bind(this);

  this.meetProductpagination = document.querySelector(this.data.pagination);
  this.meetProductcontainer = document.querySelector(this.data.container);

  this.meetProductInitialize();
};

MeetAjaxForProduct.prototype.meetProductInitialize = function () {
  if (this.meetProductcontainer) {
    var initialidata = {
      click: this.meetProductClick,
      scroll: this.meetProductScroll,
    };
    if (initialidata[this.data.method]) {
      initialidata[this.data.method]();
    }
  }
};

MeetAjaxForProduct.prototype.meetProductScroll = function () {
  if (this.meetProductpagination) {
    document.addEventListener("scroll", this.meetProductPaginationlnView);
    window.addEventListener("resize", this.meetProductPaginationlnView);
    window.addEventListener(
      "orientationchange",
      this.meetProductPaginationlnView
    );
  }
};

MeetAjaxForProduct.prototype.meetProductClick = function () {
  console.log("[Click bind] pagination element:", this.meetProductpagination);
  if (this.meetProductpagination) {
    this.nextPageLinkElement = this.meetProductpagination.querySelector("a");
    console.log(
      "[Click bind] link element:",
      this.nextPageLinkElement,
      "href:",
      this.nextPageLinkElement?.href
    );
    this.clickActive = true;
    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.removeEventListener(
        "click",
        this.meetStopProductMultipleClicks
      );
      this.nextPageLinkElement.addEventListener(
        "click",
        this.meetStopProductMultipleClicks
      );
    }
  }
};

MeetAjaxForProduct.prototype.meetStopProductMultipleClicks = function (event) {
  event.preventDefault();
  if (this.clickActive) {
    this.originalText = this.nextPageLinkElement.innerHTML;
    this.nextPageLinkElement.innerHTML = this.data.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  }
};

MeetAjaxForProduct.prototype.meetProductPaginationlnView = function () {
  var top =
    this.meetProductpagination.getBoundingClientRect().top - this.data.offset;
  var bottom =
    this.meetProductpagination.getBoundingClientRect().bottom +
    this.data.offset;

  if (top <= window.innerHeight && bottom >= 0) {
    this.nextPageLinkElement = this.meetProductpagination.querySelector("a");
    this.removeScrollListener();

    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.innerHTML = this.data.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.loadMore();
    }
  }
};

MeetAjaxForProduct.prototype.loadMore = function () {
  var self = this;
  var loaderElement = document.getElementById("loader");
  if (loaderElement) loaderElement.style.display = "block";

  fetch(this.nextPageUrl)
    .then(function (res) {
      return res.text();
    })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, "text/html");

      var cratedPagination = doc.querySelector(self.data.pagination);
      var cratedContaner = doc.querySelector(self.data.container);

      if (cratedPagination) {
        self.meetProductpagination.innerHTML = cratedPagination.innerHTML;
      } else {
        self.meetProductpagination.innerHTML = "";
      }

      if (cratedContaner) {
        self.meetProductcontainer.insertAdjacentHTML(
          "beforeend",
          cratedContaner.innerHTML
        );

        /* 追加された要素の reveal-on-scroll 属性を削除して表示状態にする */
        var revealElements =
          self.meetProductcontainer.querySelectorAll("[reveal-on-scroll]");
        revealElements.forEach(function (el) {
          el.removeAttribute("reveal-on-scroll");
        });
      }

      if (self.data.callback && typeof self.data.callback === "function") {
        self.data.callback(doc);
      }

      if (loaderElement) loaderElement.style.display = "none";

      if (!doc.querySelector(self.data.pagination + " a")) {
        self.removeScrollListener();
      } else {
        self.meetProductInitialize();
      }
    })
    .catch(function (err) {
      console.error("[LoadMore] error:", err);
      if (loaderElement) loaderElement.style.display = "none";
    });
};

MeetAjaxForProduct.prototype.removeScrollListener = function () {
  document.removeEventListener("scroll", this.meetProductPaginationlnView);
  window.removeEventListener("resize", this.meetProductPaginationlnView);
  window.removeEventListener(
    "orientationchange",
    this.meetProductPaginationlnView
  );
};

MeetAjaxForProduct.prototype.meetProductDestroy = function () {
  var yereData = {
    click: this.removeClickListener,
    scroll: this.removeScrollListener,
  };
  if (yereData[this.data.method]) {
    yereData[this.data.method]();
  }
  return this;
};

MeetAjaxForProduct.prototype.removeClickListener = function () {
  if (this.nextPageLinkElement) {
    this.nextPageLinkElement.removeEventListener(
      "click",
      this.meetStopProductMultipleClicks
    );
  }
};
